import { Delete } from "@mui/icons-material";
import { Button, Checkbox, IconButton, styled } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import get from "lodash/get";
import { useState } from "react";

const StyledDataGrid = styled(DataGrid)({
    minHeight: "150px",
    "& .MuiDataGrid-columnSeparator": {
        display: "none",
    },
    "& .MuiDataGrid-cell": {
        whiteSpace: "normal",
        wordWrap: "break-word",
        lineHeight: "1.4",
        padding: "8px",
        display: "flex",
        alignItems: "center",
        fontWeight: 400,
        fontSize: "13px",
        color: "#000000de",
    },
    "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
        outline: "none !important",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
        color: "rgb(158, 158, 158)",
        fontSize: "12px",
        fontWeight: 600,
        textTransform: "uppercase",
        textAlign: "left",
    },
});

const StyledCheckbox = styled(Checkbox)({
    transform: "scale(1.0)",
    padding: "0px !important",
    "&.MuiCheckbox-indeterminate svg": {
        color: "#2C99D2 !important",
    },
});

const ProxyDataGrid = (props) => {
    const { userAccount, handleDeleteProxy, userAllowedProxies } = props;

    const rows = userAllowedProxies.map((proxy, index) => ({
        id: index,
        name: proxy["name"],
    }));

    const [selectedRows, setSelectedRows] = useState([]);

    const updateRemovedProxies = async (proxyIds, selectedRows, selection) => {
        const result = await handleDeleteProxy(proxyIds, selectedRows);
        if (result) {
            setSelectedRows(selection);
        }
    };

    const columns = [
        {
            field: "checkbox",
            headerName: "",
            width: 5,
            sortable: false,
            disableColumnMenu: true,
            renderHeader: () => {
                const allSelected = rows.length > 0 && selectedRows.length === rows.length;
                const someSelected = selectedRows.length > 0 && selectedRows.length < rows.length;
                return (
                    <StyledCheckbox
                        checked={allSelected}
                        indeterminate={someSelected}
                        onChange={(e) => {
                            if (e.target.checked) {
                                const newSelection = rows.map((row) => row["id"]);
                                setSelectedRows(newSelection);
                            } else {
                                setSelectedRows([]);
                            }
                        }}
                    />
                );
            },
            renderCell: (params) => {
                return (
                    <StyledCheckbox
                        checked={selectedRows.includes(params.id)}
                        onChange={(e) => {
                            if (e.target.checked) {
                                setSelectedRows([...selectedRows, params.id]);
                            } else {
                                setSelectedRows(selectedRows.filter((row) => row !== params.id));
                            }
                        }}
                    />
                );
            },
        },
        { field: "name", headerName: "Name", width: 190, disableColumnMenu: true },
        {
            field: "actions",
            headerName: "delete",
            width: 150,
            renderHeader: () => (
                <Button
                    disabled={selectedRows.length === 0}
                    sx={{ color: "rgb(158, 158, 158)" }}
                    onClick={() => {
                        const proxyIds = selectedRows.map((id) =>
                            get(userAccount, "allowedProxies[" + id + "][userProxyKey]")
                        );
                        updateRemovedProxies(proxyIds, selectedRows, []);
                    }}
                >
                    Delete All Selected
                </Button>
            ),
            renderCell: (params) => {
                return (
                    <IconButton
                        sx={{ color: "rgb(44, 153, 210)" }}
                        onClick={() => {
                            updateRemovedProxies(
                                [get(userAccount, "allowedProxies[" + params.id + "][userProxyKey]")],
                                [params.id],
                                selectedRows
                                    .filter((row) => row !== params.id)
                                    .map((row) => {
                                        if (row > params.id) {
                                            return row - 1;
                                        } else {
                                            return row;
                                        }
                                    })
                            );
                        }}
                    >
                        <Delete />
                    </IconButton>
                );
            },
            sortable: false,
            filterable: false,
            hideable: false,
            align: "right",
            disableColumnMenu: true,
        },
    ];

    return (
        <div>
            <StyledDataGrid columns={columns} rows={rows} hideFooter />
        </div>
    );
};

export default ProxyDataGrid;
